import { Component, OnChanges, Input } from '@angular/core';
import { Activity, Lap } from '../models';

@Component({
  selector: 'app-strava-table',
  templateUrl: './strava-table.component.html',
  styleUrls: ['./strava-table.component.scss'],
})
export class StravaTableComponent implements OnChanges {

  @Input() laps: Lap[];
  @Input() activity: Activity;
  @Input() isActual = false;
  @Input() unit = 'km';
  @Input() colors;
  @Input() textColor;

  unitSize = this.unit === 'km' ? 1000 : 1609;

  constructor() { }

  ngOnChanges(){
     this.unitSize = this.unit === 'km' ? 1000 : 1609;
  }

  calcBar(lap,color){
    const min = Math.min(...this.laps.map(initialLap=>initialLap.pace));
    const dif = ((min-lap.pace)/min) * 100;
    if (dif < -99) {
      return 'linear-gradient(90deg, '+color+' 1%, rgba(0,0,0,0) 1%)';
    }
    return (
      'linear-gradient(90deg, ' +
      color +
      ' ' +
      (100 - Math.abs(dif)) +
      '%, rgba(0,0,0,0) ' +
      (100 - Math.abs(dif)) +
      '% ,rgba(0,0,0,0) 100%)'
    );
  }

}
